<template>
  <v-container fluid style="width: 100%" class="px-5">
    <div v-if="$route.name === names.BANS.LIST">
      <v-toolbar
          class="removeBtnPaddingRight rounded-t-lg"
          color="#DADADA"
          flat
      >
        <v-text-field
            clearable
            outlined
            dense
            single-line
            :disabled="isLoading"
            v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData"
            @click:clear="clearSearchData">
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn
            v-if="$vuetify.breakpoint.xsOnly"
            icon
            class="mr-0 dark-primary"
            @click="newBan"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
          <v-btn
              text
              @click="newBan"
              class="rounded-tr-lg dark-primary"
          >
            ЗАБЛОКИРОВАТЬ ПОЛЬЗОВАТЕЛЯ
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
          :headers="headers"
          :items="items"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :server-items-length="count"
          :options.sync="options"
          :footer-props="{'items-per-page-options':[10,50,100]}"
          class="elevation-1 rounded-b-lg"
      >
        <template v-slot:item.datetime_ban="{ item }">
          <span v-if="item.datetime_ban">{{ displayDate(item.datetime_ban) }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.auto_unban="{ item }">
          <span v-if="item.auto_unban">{{ displayDate(item.auto_unban) }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.datetime_unban="{ item }">
          <span v-if="item.datetime_unban">{{ displayDate(item.datetime_unban) }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.reason="{ item }">
          <span v-if="item.reason">{{ item.reason }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom v-if="!item.datetime_unban">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  class="mr-2"
                  @click="unBan(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                undo
              </v-icon>
            </template>
            <span>Разблокировать</span>
          </v-tooltip>
          <v-tooltip bottom v-if="!item.datetime_unban">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  class="mr-2"
                  @click="editBan(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                edit
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  v-bind="attrs"
                  v-on="on"
              >
                horizontal_rule
              </v-icon>
            </template>
            <span>Действия недоступны</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="loadData()"
          >
            Обновить
          </v-btn>
        </template>
      </v-data-table>
      <EditDialog
          v-if="dialog_add_edit"
          :opened="dialog_add_edit"
          :edit="edit_status"
          :ban-data="bans_data"
          @close="closeEditDialog"
      ></EditDialog>
      <ApplyDialog
          v-if="dialog_delete"
          :opened="dialog_delete"
          :get-text="() => `Вы уверены, что хотите удалить запись ?`"
          @close="closeDeleteDialog"
      ></ApplyDialog>
      <ApplyDialog
          v-if="dialog_unban"
          :opened="dialog_unban"
          :get-text="() => `Вы уверены, что хотите разблокировать пользователя ?`"
          @close="closeUnbanDialog"
      ></ApplyDialog>
    </div>
    <router-view v-else></router-view>
  </v-container>
</template>

<script>
import names from "../routers/names";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {mapActions, mapGetters} from "vuex";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";
import EditDialog from "./modals/BansEditDialog.vue";
import ApplyDialog from "@/modules/core/components/ApplyDialog.vue";
import {displayDate} from "@/helper";

export default {
  name: "BansList",
  components: {EditDialog, ApplyDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список заблокированных пользователей",
      dialog_add_edit: false,
      dialog_delete: false,
      dialog_unban: false,
      edit_status: undefined,
      bans_data: undefined,
      headers: [
        {text: "ФИО", value: "user", align: "start", sortable: false, width: "20%"},
        {text: "Инициатор", value: "appointer", align: "start", sortable: false, width: "20%"},
        {text: "Дата блокировки", value: "datetime_ban", align: "center", sortable: false, width: "10%"},
        {text: "Дата планируемой разблокировки", value: "auto_unban", align: "center", sortable: true, width: "10%"},
        {text: "Дата разблокировки", value: "datetime_unban", align: "center", sortable: false, width: "10%"},
        {text: "Причина", value: "reason", align: "start", sortable: false, width: "15%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "15%"}
      ],
      search: {
        parameter: "search"
      },
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      items: "admin/getBans",
      count: "admin/getBansCount",
      isLoading: "admin/isLoadingBans",
      getCurrentUrl: "admin/getBansCurrentUrl"
    })
  },
  methods: {
    ...mapActions({
      loadBansList: "admin/loadBansList",
      deleteBans: "admin/deleteBans",
      unBans: "admin/unBans"
    }),
    displayDate: displayDate,
    loadData(url = undefined) {
      this.loadBansList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "search", this.search.value)
          return new_url
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newBan() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.bans_data = undefined
    },
    unBan(item) {
      this.dialog_unban = true
      this.bans_data = item
    },
    editBan(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.bans_data = item
    },
    deleteBan(item) {
      this.dialog_delete = true
      this.bans_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.bans_data = undefined
    },
    closeUnbanDialog(event) {
      if (event) {
        this.unBans({
          id: this.bans_data.id,
          data: {},
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_unban = false
      this.bans_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteBans({
          id: this.bans_data.id,
          finalizer: () => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.bans_data = undefined
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()) {
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
    } else {
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight >>> .v-toolbar__content {
  padding-right: 0px;
}
</style>
